// extracted by mini-css-extract-plugin
export default {"row":"row__etbb0","label":"label__wCXFO"};